import React, { useRef } from "react";
import { useState, useEffect } from "react";
import heroImage from "../assets/services/services_bg.webp";
import "../styles/services.css";

// import InsuranceCalculator from "../components/InsuranceCalculator";
import Calculator from "../components/Calculator.jsx";

// Main service heading icons
import financialStrategyIcon from "../assets/services/chart_color.webp";
import lowRiskIcon from "../assets/services/tick_colored.webp";
import insuranceIcon from "../assets/services/heart_color.webp";
import assetWealthGrowth from "../assets/services/candle_color.webp";
import taxEstateIcon from "../assets/services/glass_color.webp";
import realEstateIcon from "../assets/services/house_color.webp";

// Financial Strategy Planning Icons
import startConversationIcon from "../assets/services/finance-tile1.png";
import understandingGoalIcon from "../assets/services/finance-tile2.png";
import buildStrategyIcon from "../assets/services/finance-tile3.png";
import stayOnCourseIcon from "../assets/services/finance-tile4.png";
import celebrateSuccessIcon from "../assets/services/finance-tile5.png";

// Asset & Wealth Growth icons
import assesIcon from "../assets/services/asset-tile1.png";
import goalIcon from "../assets/services/asset-tile2.png";
import executeIcon from "../assets/services/asset-tile3.png";
import trackIcon from "../assets/services/asset-tile4.png";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const taxContent = [
    {
      title: "Smart Tax Techniques",
      content: (
        <span>
          We analyze your income sources, investments, and expenses to identify 
          legal ways to reduce your tax liability.
        </span>
      ),
    },
    {
      title: "Safeguarding Family Wealth",
      content: (
        <span>
          We help structure your assets and financial strategies to ensure 
          long-term protection of family wealth.
        </span>
      ),
    },
    {
      title: "Taking Care of Your Estate",
      content: (
        <span>
          We assist in creating wills, trusts, and other legal instruments 
          to avoid disputes, reduce taxes, and provide clarity for your beneficiaries.
        </span>
      ),
    },
  ];

  const [activeIdx, setActiveIdx] = React.useState(0);

  // Left Navbar items
const serviceTitles = [
  "Financial Strategy Planning",
  "Real Estate Advisory",       
  "Insurance & Critical Illness Solutions",
  "Asset & Wealth Growth",
  "Tax & Estate Planning",
  "Low-Risk Investments",    
];


  const serviceRefs = useRef(serviceTitles.map(() => React.createRef()));

  const scrollToService = (index) => {
    serviceRefs.current[index]?.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Left Navbar iteams end

  const [isMobile, setIsMobile] = useState(window.innerWidth < 750);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 750);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  //Function to handle the smooth redirect from home tile to here
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // Use a timeout in case sections load after navigation
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);

  // Function to handle tile click
  const navigateToContact = () => {
    // Navigate to the services page with a hash corresponding to the service index
    navigate(`/contact`);
  };
  return (
    <div className="main-section">
      {/* Hero Section */}
      <div className="hero-section">
        <img src={heroImage} alt="Background" className="hero-image" />
        <div className="hero-text-wrapper">
          <h1 className="hero-text">Services</h1>
        </div>
      </div>

      {/* Services Layout */}
      <div className="services-layout">
        {/* Left Panel */}
        <div className="services-nav">
          {serviceTitles.map((title, index) => (
            <div
              key={index}
              className="service-link"
              onClick={() => scrollToService(index)}
            >
              {title}
            </div>
          ))}
          {/* TODO: add contact button */}
          <div
            className="contact-button"
            onClick={() => navigateToContact()}
            type="button"
          >
            Contact us
          </div>
        </div>

        {/* Right Scrollable Content Panel */}
        {/* Services 1 */}
        <div className="services-content">
          <div
            ref={serviceRefs.current[0]}
            id="financial-strategy-planning"
            className="service-section"
          >
            <div className="header-row">
              <img src={financialStrategyIcon} alt="" className="header-icon" />
              <span className="header-title">
                <span className="faded"> Financial Strategy </span>
                Planning
              </span>
            </div>
            <div className="roadmap-title">Your roadmap to a secure future</div>
            <hr />
            <div className="desc">
              <p>
                A financial strategy is a comprehensive plan that looks at your
                income, expenses, financial habits, and long-term aspirations.
                It guides how you can wisely use your resources to achieve life
                goals such as buying a home, saving for your child’s education,
                retiring comfortably, or growing your wealth.
                <br />
                Our financial experts work closely with you to create strategies
                as per your goals, lifestyle, and risk tolerance. Through
                data-driven insights and regular progress reviews, we make sure
                your money is working smarter not harder so you can enjoy
                long-term financial security.
              </p>
            </div>
            <div className="simple-title">
              A simple 5-step process to guide your financial journey:
            </div>

            <div className="steps-row">
              <div className="step-card">
                <img src={startConversationIcon} alt="" className="step-icon" />
                <div className="step-title">Start the conversation</div>
                <div className="step-desc">
                  Tell us about your current financial situation & concerns.
                </div>
              </div>
              <div className="step-card">
                <img src={understandingGoalIcon} alt="" className="step-icon" />
                <div className="step-title">Understanding your Goal</div>
                <div className="step-desc">
                  We will understand, analyze and plan with purpose.
                </div>
              </div>
              <div className="step-card">
                <img src={buildStrategyIcon} alt="" className="step-icon" />
                <div className="step-title">Build Strategy</div>
                <div className="step-desc">
                  We will build a personalized strategy according to your goal.
                </div>
              </div>
              <div className="step-card">
                <img src={stayOnCourseIcon} alt="" className="step-icon" />
                <div className="step-title">Stay on course</div>
                <div className="step-desc">
                  Stay motivated and get regular updates via meetings.
                </div>
              </div>
              <div className="step-card">
                <img src={celebrateSuccessIcon} alt="" className="step-icon" />
                <div className="step-title">Celebrate Success</div>
                <div className="step-desc">
                  Celebrate the goals achieved and set new targets.
                </div>
              </div>
            </div>
          </div>

        {/* Services 2 */}
        <div
          ref={serviceRefs.current[1]}
          id="real-estate-advisory"
          className="service-section"
        >
          <div className="header-row">
            <img src={realEstateIcon} alt="" className="header-icon" />
            <span className="header-title">
              <span className="faded">Real Estate </span>Advisory
            </span>
          </div>
          <div className="roadmap-title" style={{ marginTop: 28 }}>
            Invest in property with strategy, not speculation
          </div>
          <hr />
          <div className="desc">
            Whether you’re a first-time buyer or adding to your portfolio, we
            support your property decisions with real data and financial
            alignment.
          </div>
          <div className="section-subtitle">
            How we help you invest smart:
          </div>
          <div className="steps-row">
            <div className="step-card">
              <div className="step-title">Evaluate Financial Readiness</div>
              <div className="step-desc">
                We assess your budget, EMI capacity, and mortgage eligibility
                before you begin.
              </div>
            </div>
            <div className="step-card">
              <div className="step-title">Define Investment Purpose</div>
              <div className="step-desc">
                Self-use, rental income, resale, or diversification? Your goal
                shapes everything from location to property type.
              </div>
            </div>
            <div className="step-card">
              <div className="step-title">Research &amp; Shortlisting</div>
              <div className="step-desc">
                We guide you on key selection criteria like legal checks,
                builder reputation, ROI potential, and market timing.
              </div>
            </div>
            <div className="step-card">
              <div className="step-title">Support with Legal Process</div>
              <div className="step-desc">
                From selecting a lender to reviewing documentation, mortgages,
                etc., we simplify the process and reduce risk.
              </div>
            </div>
            <div className="step-card">
              <div className="step-title">Long Term Planning</div>
              <div className="step-desc">
                After purchase, we help with rental planning, resale strategy,
                or long-term holding depending on your financial goals.
              </div>
            </div>
          </div>
          {" "}
                <a
                  href="https://serenityymaison.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{  textDecoration: "none",
                  color: "#F96E2A",
                  display: "block",
                  textAlign: "center",
                  fontSize: "1.35rem", // increased by ~5px compared to default (16px → 20px)
                  fontWeight: "600",
                  marginTop: "20px"}}
                >
                  🔗 Serenityy Maison ↗
                </a>
        </div>

        {/* Services 3 */}
          <div
            ref={serviceRefs.current[2]}
            id="insurance-critical-illness"
            className="service-section"
          >
            <div className="header-row">
              <img src={insuranceIcon} alt="" className="header-icon" />
              <span className="header-title">
                <span className="faded">Insurance & Critical Illness </span>
                Solutions
              </span>
            </div>

            <div className="roadmap-title" style={{ marginTop: 28 }}>
              How much life insurance do you really need?
            </div>
            <hr />
            <div className="desc" style={{ marginBottom: 34 }}>
              The right cover isn’t a guess, it’s a calculation. A quick and
              clear way to know how much you need.
            </div>

            {/* Insurance Calculator */}
            <Calculator />
          </div>

        {/* Services 4 */}
          <div
            ref={serviceRefs.current[3]}
            id="asset-wealth-growth"
            className="service-section"
          >
            <div className="header-row">
              <img src={assetWealthGrowth} alt="" className="header-icon" />
              <span className="header-title">
                <span className="faded">Asset & Wealth </span>Growth
              </span>
            </div>
            <div className="roadmap-title" style={{ marginTop: 28 }}>
              A structured plan to build, grow, and protect your assets
            </div>
            <hr />
            <div className="desc">
              Wealth creation is not a one-time decision but it’s a continuous
              process. Our asset-building framework focuses on aligning your
              financial resources with clear, measurable goals.
            </div>
            <div className="section-subtitle">Here’s how we work with you:</div>
            <div className="steps-row">
              <div className="step-card">
                <img src={assesIcon} alt="" className="step-icon" />
                <div className="step-title">Assess</div>
                <div className="step-desc">
                  We begin with a full review of your income, savings,
                  liabilities, and existing assets.
                </div>
              </div>
              <div className="step-card">
                <img src={goalIcon} alt="" className="step-icon" />
                <div className="step-title">Set Goals</div>
                <div className="step-desc">
                  Together, we define growth goals — such as retirement corpus,
                  real estate purchase, or passive income generation.
                </div>
              </div>
              <div className="step-card">
                <img src={executeIcon} alt="" className="step-icon" />
                <div className="step-title">Execute</div>
                <div className="step-desc">
                  As per your risk profile, we implement the plan using a mix of
                  instruments (mutual funds, real estate, bonds, etc.).
                </div>
              </div>
              <div className="step-card">
                <img src={trackIcon} alt="" className="step-icon" />
                <div className="step-title">Track</div>
                <div className="step-desc">
                  We review your asset growth periodically, making changes where
                  needed.
                </div>
              </div>
            </div>
          </div>

        {/* Services 5 */}
          <div
            ref={serviceRefs.current[4]}
            id="tax-estate-planning"
            className="service-section"
          >
            <div className="header-row">
              <img src={taxEstateIcon} alt="" className="header-icon" />
              <span className="header-title">
                <span className="faded">Tax &amp; Estate </span>Planning
              </span>
            </div>
            <div className="roadmap-title" style={{ marginTop: 28 }}>
              Reduce tax burden legally and strategically
            </div>
            <hr />
            <div className="desc">
              Tax planning is not about avoiding tax, it’s about managing it
              smartly. We help individuals and businesses make informed
              decisions that reduce their tax liability while staying fully
              compliant with the law.
            </div>
            <div className="desc" style={{ marginBottom: 20, marginTop: 8 }}>
              Together, we can ensure that your family's future is secure
            </div>

            {/* Interactive Table/Box */}
            <div className="tax-estate-box-outer">
              <div className="tax-estate-box-inner">
                <div className="tax-estate-box-left">
                  {taxContent.map((item, idx) => (
                    <div
                      key={idx}
                      className={`tax-estate-box-row ${
                        activeIdx === idx ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveIdx(idx)}
                      tabIndex={0}
                      role="button"
                      aria-pressed={activeIdx === idx}
                    >
                      {item.title}
                    </div>
                  ))}
                </div>
                <div className="tax-estate-box-right">
                  <div className="tax-estate-box-content" key={activeIdx}>
                    {taxContent[activeIdx].content}
                  </div>
                </div>
              </div>
            </div>
          </div>

        {/* Services 6 */}
        <div
          ref={serviceRefs.current[5]}
          id="low-risk-investments"
          className="service-section"
        >
          <div className="header-row">
            <img src={lowRiskIcon} alt="" className="header-icon" />
            <span className="header-title">
              <span className="faded">Low-Risk </span>Investments
            </span>
          </div>
          <div className="roadmap-title">
            Stay safe while building your future
          </div>
          <hr />
          <div className="desc">
            In a volatile market, putting a portion of your portfolio in
            lower-risk assets can provide much-needed steadiness. It's more
            than simply the money; it's also about peace of mind.
          </div>

          <div className="why-title">Why choose low-risk options?</div>
          <ul className="why-list">
            <li>
              <b>Capital Protection:</b> Secure investments chosen to protect
              100% of the capital at all times.
            </li>
            <li>
              <b>Steady monthly payouts:</b> Earn consistent returns without
              exposing your portfolio to unnecessary risks.
            </li>
          </ul>

          <div className="graph-section">
            <svg
                viewBox={isMobile ? "0 0 582 282" : "0 0 682 282"}
                // viewBox="0 0 682 282"
                fill="none"
                preserveAspectRatio="xMidYMid meet"
                xmlns="http://www.w3.org/2000/svg"
                className="responsive-svg"
              >
                <text
                  x="538.5"
                  y="183.5"
                  fontFamily="Arial"
                  fontSize="18"
                  fill="green"
                  className="capital-protection"
                >
                  Capital Protection
                </text>
                <text
                  x="7"
                  y="278"
                  fontFamily="Arial"
                  fontSize="18"
                  fill="black"
                >
                  Initial Investment
                </text>
                <text
                  x="12"
                  y="181"
                  fontFamily="Arial"
                  fontSize="18"
                  fill="black"
                  transform="rotate(-90 7 175)"
                >
                  Investment
                </text>
                <text
                  x="265"
                  y="278"
                  fontFamily="Arial"
                  fontSize="18"
                  fill="black"
                >
                  Year
                </text>

                <line x1="22" y1="250" x2="22" stroke="black" strokeWidth="2" />
                <line
                  x1="22"
                  y1="249"
                  x2="521.556"
                  y2="249"
                  stroke="black"
                  strokeWidth="2"
                />
                <line
                  x1="22"
                  y1="177"
                  x2="522.5"
                  y2="177"
                  stroke="#494949"
                  strokeWidth="2"
                  strokeDasharray="6,4" // dashed pattern: 6 units dash, 4 units gap
                  strokeLinecap="round" // makes the ends of the line rounded
                />
                <path
                  className="graph-path delay-1"
                  d="M191.004 151.254C196.941 151.254 201.754 156.067 201.754 162.004V175.754H158.254V162.004C158.254 156.067 163.067 151.254 169.004 151.254H191.004Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-2"
                  d="M241 140.25C246.937 140.25 251.75 145.063 251.75 151V175.75H208.25V151C208.25 145.063 213.063 140.25 219 140.25H241Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-3"
                  d="M291 140.25C296.937 140.25 301.75 145.063 301.75 151V175.75H258.25V151C258.25 145.063 263.063 140.25 269 140.25H291Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-4"
                  d="M341 129.25C346.937 129.25 351.75 134.063 351.75 140V175.75H308.25V140C308.25 134.063 313.063 129.25 319 129.25H341Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-5"
                  d="M391 119.25C396.937 119.25 401.75 124.063 401.75 130V175.75H358.25V130C358.25 124.063 363.063 119.25 369 119.25H391Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-6"
                  d="M441 111.25C446.937 111.25 451.75 116.063 451.75 122V175.75H408.25V122C408.25 116.063 413.063 111.25 419 111.25H441Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  className="graph-path delay-7"
                  d="M491 91.25C496.937 91.25 501.75 96.0629 501.75 102V175.75H458.25V102C458.25 96.0629 463.063 91.25 469 91.25H491Z"
                  stroke="#65C1F6"
                  strokeWidth="1.5"
                />
                <path
                  d="M76.9991 224.059C76.9914 223.678 76.9725 223.302 76.943 222.942C76.7817 220.966 76.2987 218.958 75.5078 216.974C73.5066 211.953 70.0058 207.739 65.3835 204.787L65.3526 204.767L65.3179 204.776C64.5066 204.991 63.6837 205.04 62.8283 204.907L62.3111 204.827L62.7741 205.096C65.1048 206.451 67.1144 208.259 68.747 210.47C68.8803 210.651 68.8478 210.834 68.8168 210.926C68.761 211.092 68.632 211.221 68.4957 211.246C68.3859 211.266 68.2854 211.217 68.2025 211.105C64.4067 205.965 58.5863 203.131 52.6358 203.523C52.4965 203.531 52.3943 203.479 52.3291 203.369C52.2501 203.235 52.2441 203.04 52.3142 202.884C52.3516 202.801 52.4444 202.659 52.6463 202.646C54.9876 202.491 57.3319 202.823 59.6159 203.632L60.1142 203.808L59.698 203.455C59.0899 202.94 58.5683 202.319 58.1476 201.608L58.128 201.575L58.0934 201.565C56.2848 201.079 54.4487 200.797 52.6363 200.727C51.2785 200.675 49.9066 200.746 48.557 200.937C48.112 200.397 47.6674 199.841 47.237 199.303C46.9878 198.992 46.7386 198.68 46.4882 198.37C45.7548 197.462 45.0145 196.624 44.0239 196.341C43.7172 196.253 43.4619 196.25 43.2429 196.332C42.7982 196.499 42.5008 196.992 42.3334 197.841C42.0459 199.298 42.0169 200.807 41.989 202.266L41.9758 202.956C41.8429 203.021 41.7105 203.088 41.5789 203.157C38.5477 204.734 36.0421 206.964 34.1318 209.784L34.0653 209.883C33.8268 210.237 33.5915 210.595 33.3559 210.954C32.6389 212.044 31.8975 213.172 31.0661 214.173L30.8965 214.377L31.1442 214.341C32.1342 214.198 33.2345 214.624 34.0895 215.481C34.8759 216.27 35.4977 217.297 35.9378 218.533C37.3016 222.367 36.6634 227.774 34.4854 230.843C33.7688 231.853 32.9169 232.525 31.9535 232.84L31.7553 232.905L31.9325 233.023C32.315 233.278 32.7584 233.575 33.1824 233.873C34.1444 234.548 35.0289 235.151 35.8863 235.716C37.769 236.958 39.4824 237.984 41.1222 238.853C41.0755 239.462 41.0432 240.065 41.0146 240.6C40.9805 241.24 40.9508 241.793 40.905 242.242C40.8397 242.881 40.7655 243.606 40.8073 244.314C40.8202 244.533 40.8411 244.726 40.8706 244.905C41.037 245.912 41.5086 246.72 42.1646 247.121C43.1395 247.718 44.3373 247.335 45.133 246.778C46.3515 245.925 47.295 244.484 48.102 242.243C48.1585 242.086 48.2127 241.926 48.2653 241.766C50.3452 242.32 52.5042 242.648 54.6838 242.739C56.7416 242.826 58.7655 242.697 60.7015 242.358C60.7284 242.608 60.7557 242.855 60.7825 243.097C60.8717 243.903 60.9559 244.665 60.9947 245.324C61.0118 245.614 61.0339 245.951 61.0794 246.285C61.1746 246.983 61.3557 247.491 61.6496 247.882C62.0686 248.439 62.7517 248.778 63.573 248.836C63.6604 248.842 63.748 248.845 63.8357 248.845C65.0754 248.845 66.3465 248.238 67.3607 247.153C68.2618 246.188 68.9679 244.856 69.4594 243.195C69.9479 241.543 70.1152 239.962 69.9567 238.492C72.5188 236.559 74.4522 234.041 75.703 231.006C76.6119 228.802 77.0479 226.464 76.9991 224.059Z"
                  fill="#F3977F"
                />
                <path
                  d="M92.4827 212.914C92.4788 212.914 92.4751 212.914 92.4714 212.914C92.2331 212.919 91.9798 213.092 91.9862 213.46C92.0091 214.766 91.5034 216.005 90.5987 216.861C89.7215 217.69 88.5639 218.058 87.4986 217.848C87.8363 217.07 88.0358 216.233 88.0919 215.361C88.1648 214.227 87.9057 212.036 86.9002 210.982C86.4653 210.527 85.9426 210.34 85.3474 210.43C84.6853 210.529 84.1755 210.913 83.8326 211.571C83.2262 212.734 83.3124 214.501 83.7012 215.573C84.1323 216.762 84.9236 217.767 85.931 218.406C84.806 219.904 83.1502 220.604 81.5979 220.24C82.6075 218.088 82.6799 215.556 81.7809 213.781C81.2972 212.826 80.5031 212.26 79.6505 212.26C79.6378 212.26 79.6251 212.26 79.6122 212.26C78.798 212.276 78.0836 212.817 77.6522 213.745C76.6865 215.822 77.507 218.363 78.8165 219.8C79.1678 220.185 79.5697 220.51 80.0117 220.767C79.1671 221.823 78.0442 222.589 76.8471 222.927C76.8364 222.93 76.8291 222.941 76.8302 222.953C76.8593 223.31 76.878 223.683 76.8858 224.062C76.886 224.069 76.889 224.076 76.8943 224.081C76.8983 224.085 76.9033 224.087 76.9084 224.087C76.9098 224.087 76.9114 224.086 76.9128 224.086C78.5911 223.709 80.0592 222.689 81.0486 221.214C82.1771 221.552 83.4106 221.466 84.523 220.97C85.4798 220.544 86.3137 219.824 86.9354 218.888C87.6086 219.111 88.2895 219.154 88.9592 219.015C91.2706 218.534 93.0449 216.094 92.9989 213.459C92.9925 213.099 92.7363 212.914 92.4827 212.914ZM80.623 219.861C80.5596 219.826 80.4943 219.791 80.4307 219.752C79.1353 218.954 78.2577 217.359 78.2465 215.783C78.2439 215.409 78.297 214.14 79.0912 213.553C79.3752 213.343 79.6643 213.285 79.9501 213.378C80.3722 213.517 80.7781 213.992 81.0364 214.649C81.7056 216.352 81.5587 218.202 80.623 219.861ZM87.0861 215.205C87.049 215.99 86.8529 216.751 86.5036 217.468C86.2164 217.302 85.9483 217.093 85.7063 216.848C84.5898 215.718 83.9039 213.689 84.6888 212.25C84.9164 211.833 85.2231 211.604 85.5537 211.604C85.5569 211.604 85.5601 211.604 85.5633 211.604C85.9419 211.609 86.3235 211.913 86.5844 212.418C87.0893 213.395 87.1154 214.583 87.0861 215.205Z"
                  fill="#E5735C"
                />
                <path
                  d="M35.9782 235.543L35.8672 235.47L35.8434 235.611C35.6213 236.928 35.5435 238.386 35.4808 239.558C35.4468 240.197 35.4173 240.75 35.3714 241.198C35.2822 242.07 35.1901 242.972 35.3369 243.861C35.5032 244.868 35.9749 245.676 36.631 246.077C36.9789 246.29 37.3552 246.379 37.7316 246.379C38.4096 246.379 39.0877 246.092 39.5995 245.734C40.0921 245.389 40.5521 244.931 40.9669 244.372L40.9899 244.341L40.9876 244.301C40.9468 243.611 41.0199 242.896 41.0845 242.265C41.131 241.811 41.1606 241.255 41.195 240.612C41.2245 240.059 41.2581 239.431 41.3077 238.801L41.3131 238.731L41.2563 238.701C39.6042 237.828 37.8777 236.796 35.9782 235.543Z"
                  fill="#E5735C"
                />
                <path
                  d="M44.7834 208.98C44.9052 209.071 45.0389 209.116 45.1824 209.116C45.2465 209.116 45.3125 209.107 45.3802 209.089C45.9119 208.947 46.0925 208.383 46.2517 207.886C46.3401 207.61 46.4236 207.348 46.5565 207.156C47.0465 206.447 47.641 206.774 48.2707 207.121L48.3563 207.168C48.706 207.36 49.3651 207.528 49.7477 207.208C49.8759 207.101 49.958 206.95 49.992 206.759C50.1731 205.741 49.2441 204.577 48.6293 203.806C48.5331 203.685 48.444 203.574 48.367 203.473C47.6588 202.543 46.8804 201.668 46.0534 200.875C45.6825 200.519 45.1325 200.061 44.6427 200.2C44.0455 200.368 43.9993 201.127 43.9656 201.681C43.9622 201.736 43.9589 201.789 43.9553 201.84C43.8161 203.752 43.8831 205.672 44.1548 207.547C44.202 207.873 44.3575 208.664 44.7834 208.98Z"
                  fill="#E5735C"
                />
                <path
                  d="M36.1061 218.459V218.459C35.6556 217.193 35.0179 216.141 34.2105 215.331C33.3166 214.435 32.1615 213.99 31.1211 214.141L31.0974 214.144C31.0842 214.145 31.071 214.147 31.0579 214.149C30.7024 214.209 30.3631 214.322 30.0352 214.431C29.4994 214.609 28.9932 214.777 28.4257 214.732C28.2065 214.715 28.0019 214.685 27.804 214.656C27.1108 214.554 26.5126 214.466 25.7557 214.978C25.0641 215.446 24.4862 216.234 24.0843 217.257C23.0404 219.913 22.7249 223.286 23.261 226.059C23.7153 228.409 25.3259 230.8 27.3638 232.15C28.4552 232.873 29.5866 233.245 30.656 233.245C31.12 233.245 31.5724 233.175 32.0046 233.033C33.0047 232.705 33.8871 232.01 34.6272 230.968C36.8418 227.848 37.4914 222.354 36.1061 218.459Z"
                  fill="#E5735C"
                />
                <path
                  d="M42.422 207.594C42.4029 207.277 42.3959 206.953 42.3892 206.64C42.3828 206.35 42.3763 206.051 42.3604 205.757C42.3542 205.638 42.2601 205.563 42.1728 205.558C42.0815 205.552 42.0093 205.619 41.9948 205.718C41.9166 206.261 41.7041 208.139 42.255 209.502C42.2792 209.561 42.3279 209.596 42.3835 209.596C42.3927 209.596 42.4019 209.595 42.4113 209.593C42.4838 209.579 42.5398 209.51 42.5441 209.431C42.5666 209.028 42.5226 208.621 42.4802 208.227C42.4578 208.019 42.4345 207.804 42.422 207.594Z"
                  fill="#E5735C"
                />
                <path
                  d="M41.6372 203.15C41.5299 203.124 41.4275 203.098 41.3331 203.07C39.5299 202.524 37.7734 201.71 36.0747 200.921C35.7213 200.758 35.3683 200.594 35.0147 200.432C33.9999 199.969 33.0059 199.572 32.0044 199.796C31.6937 199.866 31.4625 199.987 31.2974 200.166C30.9617 200.531 30.8856 201.119 31.065 201.965C31.3726 203.415 31.9338 204.789 32.4766 206.118L34.1196 210.14L34.2775 209.906C36.1698 207.112 38.6525 204.903 41.6567 203.339L41.9018 203.212L41.6372 203.15Z"
                  fill="#E5735C"
                />
                <path
                  d="M47.6825 238.919C46.4596 237.875 45.0254 237.238 43.4193 237.026C43.0762 236.98 42.8915 237.24 42.8619 237.518C42.8252 237.865 43.0157 238.254 43.3981 238.305C44.7236 238.48 45.9638 239.053 47.0845 240.01C47.1835 240.095 47.2899 240.138 47.3955 240.138C47.4527 240.138 47.5097 240.125 47.565 240.099C47.7487 240.014 47.8866 239.798 47.9157 239.548C47.9448 239.299 47.8599 239.07 47.6825 238.919Z"
                  fill="#E5735C"
                />
                <path
                  d="M61.1745 245.311C61.1353 244.646 61.0508 243.882 60.9613 243.073C60.9308 242.797 60.8997 242.516 60.8694 242.23L60.8584 242.126L60.7654 242.143C58.8128 242.492 56.7689 242.625 54.6899 242.538L54.584 242.534L54.5969 242.651C54.6731 243.343 54.7444 244.013 54.7797 244.613C54.8251 245.385 54.8874 246.443 55.4346 247.171C55.9998 247.923 56.8824 248.092 57.3581 248.125C57.4455 248.131 57.533 248.134 57.621 248.134C58.8604 248.134 60.1315 247.527 61.1456 246.442C61.1634 246.423 61.1802 246.402 61.197 246.382L61.2644 246.305L61.2575 246.255C61.213 245.929 61.1913 245.597 61.1745 245.311Z"
                  fill="#E5735C"
                />
                <path
                  d="M67.1023 236.786C65.0591 236.943 63.2184 237.703 61.6314 239.046C61.3237 239.306 61.3364 239.75 61.5263 240.03C61.6195 240.166 61.7602 240.264 61.9193 240.264C62.0178 240.264 62.1233 240.227 62.2287 240.138C63.6929 238.899 65.3368 238.202 67.1146 238.065C67.3294 238.049 67.5058 237.918 67.5985 237.707C67.6949 237.487 67.683 237.212 67.5686 237.022C67.467 236.855 67.3003 236.771 67.1023 236.786Z"
                  fill="#E5735C"
                />
                <path
                  d="M49.2222 201.628C49.1671 201.562 49.0792 201.556 49.0132 201.613C48.9479 201.67 48.9322 201.765 48.9756 201.841C49.1945 202.222 49.4273 202.6 49.6523 202.966C49.9063 203.378 50.169 203.805 50.4117 204.235C50.5829 204.539 50.7444 204.865 50.9006 205.18C51.1596 205.702 51.4274 206.242 51.7536 206.715C51.7818 206.756 51.8249 206.778 51.8688 206.778C51.8905 206.778 51.9124 206.773 51.9329 206.762C51.9915 206.729 52.0189 206.658 52.0007 206.585C51.4765 204.474 49.8829 202.415 49.2222 201.628Z"
                  fill="#E5735C"
                />
                <path
                  d="M51.7253 208.197C50.5085 209.221 49.4265 209.984 48.1005 210.382C46.8001 210.772 45.5045 210.769 43.7687 210.372C43.6167 210.338 43.5071 210.443 43.4762 210.565C43.4449 210.689 43.49 210.845 43.6363 210.904C44.3881 211.207 45.2057 211.35 46.0346 211.35C48.2974 211.35 50.6415 210.281 51.9407 208.472C51.9942 208.397 51.9876 208.283 51.9259 208.212C51.8707 208.149 51.7899 208.143 51.7253 208.197Z"
                  fill="#E5735C"
                />
                <path
                  d="M31.7209 218.901C31.4414 218.155 31.0501 217.756 30.6006 217.767C30.1874 217.781 29.8749 218.164 29.7485 218.537C29.6156 218.93 29.6281 219.361 29.6393 219.741C29.652 220.184 29.6677 220.628 29.6834 221.071C29.7335 222.487 29.7852 223.951 29.7351 225.383C29.7159 225.935 29.7291 226.574 29.9745 227.116C30.2922 227.818 30.6425 227.984 30.9021 227.984C30.9271 227.984 30.9515 227.982 30.9746 227.979C31.5419 227.912 32.0344 227.081 32.2099 226.334C32.4295 225.398 32.5165 224.304 32.4761 222.989C32.4296 221.489 32.1756 220.114 31.7209 218.901Z"
                  fill="#B2333F"
                />
                <path
                  d="M27.5373 218.9C27.3454 218.388 26.9151 217.838 26.4636 217.778C26.277 217.752 25.9979 217.803 25.743 218.188C25.4444 218.639 25.4571 219.255 25.4664 219.705L25.482 220.443C25.5148 221.981 25.5487 223.572 25.5309 225.138C25.5067 227.287 26.0601 227.881 26.5286 228C26.59 228.015 26.6493 228.023 26.7065 228.023C27.5188 228.023 27.8992 226.537 27.9709 226.22C28.2099 225.165 28.3241 224.018 28.2925 222.989C28.246 221.489 27.992 220.113 27.5373 218.9Z"
                  fill="#B2333F"
                />
                <path
                  d="M68.8869 210.342C67.239 208.11 65.2105 206.285 62.8582 204.918L62.8287 204.907C61.6941 204.731 60.6115 204.229 59.6984 203.455L59.6711 203.44C57.3656 202.623 54.9983 202.288 52.6362 202.445C52.4224 202.459 52.2464 202.586 52.1531 202.794C52.0549 203.012 52.0652 203.288 52.1787 203.48C52.2798 203.651 52.4482 203.737 52.6468 203.724C58.5424 203.335 64.3044 206.142 68.0634 211.233C68.1692 211.376 68.3033 211.452 68.4477 211.452C68.4733 211.452 68.4994 211.449 68.5257 211.445C68.7268 211.407 68.9075 211.232 68.9864 210.997C69.0627 210.77 69.0265 210.531 68.8869 210.342Z"
                  fill="#B2333F"
                />
                <path
                  d="M40.663 214.111C40.1186 214.101 39.6274 214.455 39.303 215.112C38.8864 215.956 38.8582 217.077 39.2371 217.718C39.521 218.199 40.0068 218.494 40.4985 218.494C40.5361 218.494 40.5739 218.492 40.6115 218.488C41.3154 218.423 41.7493 217.755 41.9205 217.152C41.98 216.943 42.0206 216.702 42.0377 216.455C42.0914 215.683 41.9212 214.974 41.5825 214.559C41.3462 214.269 41.0367 214.118 40.663 214.111Z"
                  fill="#B2333F"
                />
                <path
                  d="M72.5029 218.758C72.3434 217.964 72.0909 216.946 71.5496 216.119C71.1367 215.488 70.6448 215.165 70.1991 215.231C69.9302 215.27 69.556 215.473 69.3004 216.215C69.031 216.996 68.815 217.814 68.606 218.606C68.239 219.997 67.8595 221.434 67.1827 222.686C65.8338 225.183 63.4757 226.687 61.1953 228.142C59.1779 229.429 57.0917 230.76 55.6497 232.785C54.9604 233.753 54.5765 234.704 54.5089 235.612C54.4233 236.76 54.8459 237.723 55.6683 238.255C56.0633 238.511 56.512 238.637 56.9678 238.637C57.5314 238.637 58.1059 238.444 58.603 238.063C59.1497 237.644 59.6452 237.212 60.1244 236.795C61.4573 235.634 62.7162 234.537 64.6723 234.132C65.0954 234.044 65.5362 233.984 65.9623 233.926C67.0321 233.78 68.1382 233.629 69.0905 233.03C73.1793 230.457 73.3713 223.085 72.5029 218.758Z"
                  fill="#F6AFA1"
                />
                <path
                  d="M67.867 239.316C67.5519 239.116 67.1645 239.105 66.83 239.288C66.517 239.458 66.3107 239.765 66.2635 240.129C66.2265 240.417 66.2023 240.695 66.179 240.964C66.119 241.654 66.0625 242.306 65.7959 243.007C65.5518 243.649 65.2374 244.269 64.9333 244.868C64.7914 245.148 64.6497 245.427 64.5141 245.71C64.3611 246.029 64.182 246.495 64.3939 246.861C64.5402 247.114 64.7836 247.187 65.015 247.187C65.2451 247.187 65.4634 247.115 65.5633 247.077C66.654 246.657 67.6091 245.777 68.1839 244.662C68.7586 243.546 68.9593 242.183 68.7346 240.921C68.5962 240.144 68.2961 239.589 67.867 239.316Z"
                  fill="#F6AFA1"
                />
                <path
                  d="M45.9103 240.075C45.655 239.917 45.4324 239.884 45.2482 239.975C44.8943 240.151 44.775 240.734 44.6789 241.202C44.6556 241.316 44.6339 241.422 44.6106 241.511C44.3639 242.457 43.9796 243.339 43.4686 244.133L43.3906 244.253C43.2425 244.479 43.0894 244.713 42.9957 244.983C42.8649 245.361 42.8887 245.746 43.0593 246.014C43.2316 246.284 43.5111 246.393 43.8142 246.393C44.0583 246.393 44.3178 246.322 44.5485 246.209C45.4071 245.786 46.1068 244.989 46.4683 244.023C46.8294 243.056 46.8448 241.942 46.5101 240.964C46.3594 240.523 46.1631 240.232 45.9103 240.075Z"
                  fill="#F6AFA1"
                />
                <path
                  d="M63.7617 189.791C59.9558 189.791 56.8594 193.243 56.8594 197.487C56.8594 198.997 57.253 200.46 57.9977 201.719C58.4295 202.449 58.965 203.087 59.5894 203.616C60.5272 204.411 61.6389 204.926 62.8044 205.107C63.1274 205.157 63.4495 205.182 63.7616 205.182C64.2963 205.182 64.8343 205.112 65.3603 204.972C68.4831 204.146 70.6641 201.068 70.6641 197.487C70.6641 193.243 67.5677 189.791 63.7617 189.791Z"
                  fill="#F3B24C"
                />
                <path
                  d="M58.4487 184.301C57.9184 182.341 56.7351 180.728 55.1166 179.76C53.4985 178.792 51.6385 178.584 49.8801 179.175C48.1218 179.767 46.6751 181.086 45.8066 182.89C44.9383 184.695 44.7521 186.768 45.2826 188.729C45.8128 190.689 46.9962 192.302 48.6147 193.27C49.6285 193.877 50.7374 194.185 51.8567 194.185C52.5237 194.185 53.1945 194.075 53.8512 193.855C55.6094 193.263 57.0561 191.944 57.9246 190.14C58.7929 188.335 58.9791 186.262 58.4487 184.301Z"
                  fill="#F3B24C"
                />
                <path
                  d="M63.7623 190.616C60.3587 190.616 57.5998 193.692 57.5996 197.487C57.5998 201.282 60.3587 204.358 63.7623 204.358C67.166 204.358 69.9246 201.282 69.9249 197.487C69.9246 193.692 67.166 190.616 63.7623 190.616ZM67.755 201.939C66.7325 203.078 65.3225 203.782 63.7622 203.783C62.2022 203.782 60.7922 203.078 59.7695 201.939C58.7473 200.798 58.1157 199.226 58.1157 197.487C58.1157 195.748 58.7473 194.176 59.7695 193.035C60.7922 191.896 62.2022 191.192 63.7622 191.191C65.3224 191.192 66.7325 191.896 67.755 193.035C68.7772 194.176 69.4088 195.748 69.4088 197.487C69.4088 199.226 68.7772 200.798 67.755 201.939Z"
                  fill="#EE7344"
                />
                <path
                  d="M65.4748 196.737C65.1703 196.517 64.7834 196.419 64.3138 196.439C64.2026 196.445 64.0913 196.457 63.9801 196.469C63.8554 196.482 63.7308 196.496 63.6062 196.5C63.5093 196.504 63.4219 196.501 63.3474 196.494C63.2821 196.481 63.2212 196.463 63.1711 196.444C63.1309 196.422 63.0924 196.397 63.0634 196.376C63.0271 196.341 62.9932 196.303 62.9676 196.27C62.9342 196.216 62.9044 196.159 62.8823 196.109C62.8606 196.043 62.8435 195.973 62.8325 195.913C62.8278 195.846 62.8279 195.777 62.8317 195.719C62.8446 195.643 62.8628 195.569 62.8825 195.507C62.9136 195.435 62.951 195.365 62.9893 195.304C63.0451 195.23 63.109 195.16 63.1739 195.099C63.2648 195.026 63.3646 194.962 63.4652 194.91C63.5206 194.886 63.5769 194.865 63.6339 194.847C63.7001 194.826 63.7672 194.809 63.829 194.797C63.8818 194.792 63.9349 194.788 63.9852 194.787C64.0758 194.789 64.1663 194.794 64.2537 194.802L64.3172 194.812C64.5036 194.85 64.6969 194.913 64.8893 194.999C65.0364 195.072 65.1851 195.157 65.3319 195.253C65.4485 195.33 65.5945 195.349 65.7327 195.305C65.8637 195.264 65.9687 195.172 66.028 195.047C66.1597 194.769 66.0792 194.43 65.8443 194.277C65.3601 193.959 64.8826 193.761 64.4238 193.688V193.062C64.4238 192.783 64.1795 192.557 63.8791 192.557C63.5788 192.557 63.3345 192.783 63.3345 193.062V193.768C63.0357 193.868 62.7587 194.029 62.5104 194.249C62.0698 194.639 61.8027 195.248 61.8137 195.839C61.8201 196.19 61.9126 196.536 62.0742 196.814C62.2619 197.138 62.5227 197.373 62.8498 197.515C63.1284 197.635 63.405 197.639 63.6129 197.629C63.7321 197.623 63.8515 197.611 63.9712 197.599C64.093 197.587 64.2151 197.575 64.337 197.569C64.4505 197.565 64.5505 197.567 64.6358 197.576C64.7087 197.59 64.7752 197.61 64.8308 197.632C64.8887 197.663 64.9447 197.7 64.9913 197.736C65.0481 197.79 65.102 197.85 65.1463 197.909C65.1936 197.984 65.2351 198.063 65.2667 198.138C65.2948 198.222 65.3157 198.308 65.3285 198.384C65.3366 198.483 65.3364 198.585 65.3288 198.68C65.3106 198.796 65.2817 198.912 65.2448 199.02C65.1977 199.134 65.1398 199.244 65.0766 199.343C65.0017 199.444 64.9165 199.539 64.8272 199.621C64.7068 199.718 64.5735 199.804 64.435 199.874C64.3921 199.893 64.349 199.91 64.3052 199.926C64.1795 199.972 64.0493 200.007 63.9222 200.03C63.8177 200.043 63.7126 200.048 63.6111 200.046C63.5486 200.044 63.4863 200.04 63.4295 200.033C63.3127 200.012 63.1992 199.978 63.098 199.935C63.006 199.888 62.919 199.831 62.845 199.773C62.7854 199.717 62.7306 199.657 62.6872 199.601C62.6514 199.544 62.6198 199.484 62.5931 199.422C62.5432 199.268 62.4676 199.16 62.3623 199.091C62.2453 199.015 62.0867 198.992 61.9674 199.035C61.8283 199.086 61.7065 199.204 61.6417 199.351C61.5869 199.477 61.5787 199.614 61.619 199.738C61.7494 200.138 61.975 200.463 62.3086 200.732C62.5602 200.935 62.8738 201.077 63.1919 201.132C63.2394 201.14 63.2869 201.147 63.3345 201.153V201.8C63.3345 201.963 63.391 202.118 63.4937 202.235C63.597 202.352 63.7338 202.417 63.8791 202.417C64.1795 202.417 64.4238 202.14 64.4238 201.8V201.066C64.6835 200.991 64.93 200.879 65.1581 200.731C65.4645 200.531 65.7284 200.263 65.9422 199.932C66.151 199.609 66.2869 199.208 66.3355 198.771C66.4237 197.975 66.0859 197.177 65.4748 196.737Z"
                  fill="#EE7344"
                />
                <path
                  d="M57.7443 184.539C56.9429 181.579 54.5068 179.669 51.8691 179.669C51.2819 179.669 50.6849 179.764 50.0942 179.962C47.4395 180.856 45.7264 183.572 45.7266 186.513C45.7266 187.167 45.8115 187.833 45.9896 188.491C46.7906 191.451 49.2269 193.361 51.8645 193.361C52.4518 193.361 53.049 193.266 53.6394 193.068C56.2942 192.174 58.0075 189.458 58.0071 186.518C58.0073 185.863 57.9224 185.197 57.7443 184.539ZM53.4911 192.519C52.949 192.701 52.4022 192.788 51.8645 192.788C49.4487 192.788 47.2147 191.038 46.4817 188.326C46.3182 187.722 46.2406 187.112 46.2406 186.513C46.2408 183.819 47.8098 181.329 50.2427 180.511C50.7848 180.329 51.3315 180.242 51.8691 180.242C54.2847 180.242 56.5187 181.992 57.2521 184.704C57.4156 185.309 57.4931 185.918 57.4933 186.518C57.4931 189.211 55.9237 191.702 53.4911 192.519Z"
                  fill="#EE7344"
                />
                <path
                  d="M53.3071 185.251C52.9593 185.139 52.5663 185.167 52.1228 185.339C52.0183 185.381 51.9152 185.428 51.812 185.475C51.6967 185.527 51.5815 185.58 51.4639 185.624C51.3723 185.659 51.2885 185.684 51.2154 185.701C51.1509 185.71 51.0863 185.713 51.0348 185.71C50.9907 185.702 50.9474 185.691 50.9143 185.68C50.8705 185.658 50.8287 185.633 50.7957 185.61C50.7503 185.569 50.707 185.524 50.673 185.484C50.6347 185.427 50.6004 185.366 50.575 185.313C50.553 185.249 50.5353 185.184 50.524 185.127C50.5166 185.052 50.515 184.976 50.5182 184.91C50.5291 184.831 50.5466 184.752 50.5672 184.682C50.6013 184.594 50.644 184.506 50.6905 184.427C50.7584 184.329 50.8368 184.235 50.9192 184.153C50.966 184.113 51.0143 184.075 51.0643 184.039C51.1219 183.998 51.1813 183.961 51.2373 183.93C51.2862 183.907 51.3358 183.887 51.3835 183.87C51.4701 183.842 51.558 183.818 51.6436 183.798L51.7065 183.787C51.8945 183.764 52.0946 183.762 52.3004 183.782C52.4583 183.804 52.6222 183.838 52.7878 183.883C52.9195 183.918 53.0637 183.889 53.1841 183.803C53.2985 183.721 53.3747 183.6 53.3991 183.462C53.4529 183.154 53.2886 182.857 53.0248 182.786C52.481 182.638 51.9746 182.603 51.5183 182.68L51.3568 182.083C51.3211 181.95 51.2309 181.846 51.1031 181.789C50.9824 181.735 50.8422 181.731 50.7068 181.776C50.4203 181.872 50.2456 182.167 50.3174 182.432L50.4996 183.106C50.2407 183.296 50.0182 183.539 49.8375 183.829C49.518 184.342 49.4206 185.009 49.5837 185.569C49.6802 185.901 49.8578 186.202 50.0837 186.416C50.3462 186.664 50.6559 186.805 51.0043 186.835C51.3012 186.861 51.5649 186.776 51.7617 186.699C51.874 186.656 51.985 186.606 52.096 186.556C52.209 186.505 52.322 186.454 52.4369 186.41C52.5439 186.369 52.6401 186.339 52.7233 186.32C52.7952 186.311 52.8653 186.308 52.9237 186.311C52.9867 186.322 53.0496 186.34 53.1034 186.359C53.1712 186.392 53.2381 186.432 53.296 186.474C53.3602 186.53 53.4202 186.593 53.4696 186.654C53.5177 186.725 53.56 186.8 53.5922 186.869C53.6255 186.961 53.6517 187.058 53.6686 187.151C53.6813 187.267 53.6838 187.387 53.6764 187.502C53.6605 187.626 53.6338 187.75 53.5992 187.864C53.5541 187.984 53.497 188.102 53.4332 188.209C53.3435 188.341 53.2385 188.465 53.1244 188.576C53.0884 188.608 53.0517 188.638 53.0141 188.667C52.9061 188.751 52.791 188.827 52.6759 188.889C52.5797 188.935 52.4812 188.973 52.3834 189.004C52.3233 189.022 52.2627 189.038 52.2071 189.05C52.0894 189.067 51.9725 189.071 51.8657 189.063C51.7656 189.047 51.6682 189.021 51.5824 188.99C51.5113 188.955 51.4435 188.915 51.3877 188.876C51.3391 188.833 51.2934 188.786 51.2518 188.735C51.164 188.604 51.0641 188.525 50.9461 188.494C50.8154 188.459 50.6578 188.488 50.5547 188.567C50.4349 188.66 50.3493 188.812 50.3256 188.974C50.3057 189.111 50.3334 189.244 50.4038 189.349C50.6311 189.689 50.9302 189.927 51.318 190.077C51.6103 190.189 51.9459 190.224 52.2638 190.175C52.3111 190.167 52.3582 190.159 52.405 190.149L52.5718 190.766C52.6141 190.922 52.708 191.051 52.836 191.13C52.9177 191.18 53.0068 191.205 53.0967 191.205C53.1482 191.205 53.2001 191.197 53.2508 191.18C53.3895 191.133 53.5034 191.028 53.5715 190.883C53.6395 190.738 53.6534 190.572 53.6111 190.416L53.422 189.717C53.6503 189.562 53.8563 189.376 54.0356 189.161C54.2765 188.873 54.4589 188.532 54.5775 188.148C54.6933 187.773 54.7194 187.347 54.6531 186.914C54.5317 186.127 54.0034 185.474 53.3071 185.251Z"
                  fill="#EE7344"
                />
              </svg>
          </div>

          <div className="disclaimer">
            We don’t believe that one size fits all. We evaluate your
            objectives, schedules, and risk tolerance to design a personalized
            investment plan.
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
